import { candidateName } from "./candidateName";
export function mouradApplications(candidate) {
  if (
    candidateName(candidate).toLocaleUpperCase("fr-FR") !== "MOURAD ALIOUACHENE"
  )
    return [];
  return [
    [
      "Préparateur de commandes",
      "Logistique Horizon (exemple)",
      "Saint-Denis",
      "Intérim",
      "2026-10-08",
      "Nouveau",
      "Préparation des commandes et contrôle des colis.",
    ],
    [
      "Agent de production",
      "Atelier du Centre (exemple)",
      "Aubervilliers",
      "CDD",
      "2026-10-06",
      "RDV avec Client",
      "Conditionnement et contrôle qualité en atelier.",
    ],
    [
      "Agent polyvalent",
      "Services Ensemble (exemple)",
      "Paris",
      "Intérim",
      "2026-10-02",
      "Refusé",
      "Accueil et soutien logistique sur le site client.",
    ],
  ].map(
    (
      [title, clientName, localisation, jobType, date, status, description],
      index,
    ) => ({
      key: `demo-mourad-application-${index + 1}`,
      date,
      status,
      source: "Démonstration",
      offer: {
        _id: `demo-mourad-offer-${index + 1}`,
        isDemo: true,
        title,
        clientName,
        localisation,
        jobType,
        description,
      },
    }),
  );
}
